<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Pacientes</b>
                        </h3>
                        <router-link tag="a" class="btn btn-primary pull-right" to="/cadastros/pacientes/novo" v-if="hasPermission('usuario.write')"> <span class="fa fa-plus"></span> Novo </router-link>
                    </div>
                    <div class="box-body">
                        <form action @submit.prevent="getDataTable()">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Nome do paciente</label>
                                        <input v-model="filtros.nome" type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for>Nome da mãe</label>
                                        <input v-model="filtros.nome_mae" type="text" class="form-control" />
                                    </div>
                                </div>
								<div class="col-md-2">
									<div class="form-group">
										<label for>Nº CEMAE</label>
										<input v-model="filtros.cemae" type="text" class="form-control" />
									</div>
								</div>
								<div class="col-sm-2">
                                    <div class="form-group">
                                        <label for="">CPF</label>
                                        <input type="text" v-mask="'###.###.###-##'" class="form-control" v-model="filtros.cpf" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Data de nascimento</label>
                                        <input v-model="filtros.data_nascimento" type="date" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>Rg</label>
                                        <input v-model="filtros.rg" type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for>Cartão do SUS</label>
                                        <input v-model="filtros.cartao_sus" type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for>Municipio</label>
                                        <input type="text" class="form-control" v-model="filtros.municipio" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for>&nbsp;</label>
                                        <button class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome do paciente</th>
                                    <th>Nome da mãe</th>
                                    <th>Data de nascimento</th>
                                    <th>Rg</th>
                                    <th>Cartão do SUS</th>
									<th>CPF</th>
                                    <th>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataTable.data" :key="index">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.nome_mae }}</td>
                                    <td>{{ item.data_nascimento | dataFormatada }}</td>
                                    <td>{{ item.rg }}</td>
                                    <td>{{ item.cartao_sus }}</td>
                                    <td>{{ item.cpf }}</td>
                                    <td width="10%">
                                        <router-link tag="a" :to="'/cadastros/pacientes/editar/' + item.id" title="Editar paciente" class="btn btn-sm btn-warning">
                                            <span class="fa fa-edit"></span>
                                        </router-link>
                                        <router-link tag="a" :to="'/cadastros/pacientes/historico/' + item.id" title="Histórico do paciente" class="btn btn-sm btn-success">
                                            <span class="fa fa-history"></span>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                            <div class="col-sm-7" style="text-align:right">
                                <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
export default {
	directives: {
        mask
    },
    data: () => ({
        filtros: {
            nome: "",
            nome_mae: "",
            data_nascimento: "",
            rg: "",
            cartao_sus: "",
            municipio: "",
            cpf: ""
        },
        dataTable: {}
    }),
    mounted() {
        this.filtros.nome = this.$route.query.nome ? this.$route.query.nome : "";
        this.filtros.nome_mae = this.$route.query.nome_mae ? this.$route.query.nome_mae : "";
        this.filtros.cemae = this.$route.query.cemae ? this.$route.query.cemae : "";
        this.filtros.data_nascimento = this.$route.query.data_nascimento ? this.$route.query.data_nascimento : "";
        this.filtros.rg = this.$route.query.rg ? this.$route.query.rg : "";
        this.filtros.cartao_sus = this.$route.query.cartao_sus ? this.$route.query.cartao_sus : "";
        this.filtros.municipio = this.$route.query.municipio ? this.$route.query.municipio : "";
        this.getDataTable();
    },
    methods: {
        getDataTable(page) {
            if (typeof page === "undefined" || typeof page === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {},

    components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?6dabfaad